import { render, staticRenderFns } from "./PanelDetailsArboSnapshot.vue?vue&type=template&id=56c387f2&"
import script from "./PanelDetailsArboSnapshot.vue?vue&type=script&lang=js&"
export * from "./PanelDetailsArboSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports